<template>
  <b-container>
     <b-spinner type="grow" label="Loading..."></b-spinner>
  </b-container>
</template>

<script>
    import axios from 'axios'
    import Gallery from "./Gallery";
    export default {
        name: "ConfirmEmail.vue",
        components: {Gallery},
        props :['code','token'],

        data:()=> {
            return {
                result:'',
            }
        },
        methods:{

          SendConfirmation:function(){
                 var headers = {}
                axios.post("/api/account/activate/",{code:this.code,token:this.token}, {headers: headers}).then(response => {
                    console.log(response);

                    this.result = response.data.status
                    if(this.result == 'activated'){
                        this.$router.push({name: 'profile', query:{a:'activated'}})
                        }
                    else if(this.result =='already activated') {
                        this.$router.push({name: 'gallery', query:{a:'alreadyactivated'}})
                    }
                    else{
                        this.$router.push({name: 'gallery', query:{a:'activationerror'}})
                    }

                });
          }
        },
        mounted() {
            this.SendConfirmation()

        },
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/ConfirmEmail.vue